import React, { useContext } from 'react';
import styles from "../../../../styles/pages/DocumentationPage/components/DocTabs/PostLead.module.css";
import { LangContext } from "../../../../context/LangContext";
import { ThemeContext } from "../../../../context/ThemeContext";

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;
const translations = {
    ru: {
        title: "Создание лида",
        requestInfoTitle: "Информация о запросе",
        urlLabel: "URL:",
        methodLabel: "Метод:",
        tokenLabel: "Ваш токен:",
        loading: "Загрузка...",
        error: "Ошибка",
        missing: "Отсутствует",
        requestParamsTitle: "Параметры запроса",
        tokenDescription: "Интеграционный токен.",
        requestBodyTitle: "Параметры тела запроса",
        firstNameDesc: "Имя (минимум 3, максимум 50 символов).",
        lastNameDesc: "Фамилия (минимум 3, максимум 50 символов).",
        emailDesc: "Email (максимум 255 символов).",
        passwordDesc: "Необязательный пароль лида (минимум 6, максимум 20 символов). Если параметр не передан или равен null, CRM сгенерирует пароль автоматически.",
        phoneDesc: "Телефон.",
        campaignDesc: "Название рекламной кампании (минимум 2, максимум 255 символов).",
        secondPhoneDesc: "Второй номер телефона (может быть null).",
        extraInfoDesc: "Дополнительная информация (может быть null).",
        geoDesc: "Гео. Допустимые значения: all, RU, SK, DK, LT, CZ, FR, LV, CY, NL, GE, HU, EE, GB, AT, FI, ME, KG, IE, PL, UA, PT, ES, MT, MC, NO, IT, IS, HR, GR, SE, BE, CH, DE, LU, US, HK, MY, UZ, PF, KG, AZ, AM, TJ, null.",
        curlTitle: "Пример запроса (cURL)",
        serverResponsesTitle: "Ответы сервера",
        successResponse: "Успешный запрос (201 Created)",
        domainError: "Ошибка домена (400 Bad Request)",
        unauthorizedError: "Пользователь не аутентифицирован (401 Unauthorized)",
        validationError: "Ошибка валидации (422 Unprocessable Entity)"
    },
    en: {
        title: "Create a Lead",
        requestInfoTitle: "Request Information",
        urlLabel: "URL:",
        methodLabel: "Method:",
        tokenLabel: "Your Token:",
        loading: "Loading...",
        error: "Error",
        missing: "Missing",
        requestParamsTitle: "Request Parameters",
        tokenDescription: "Integration token.",
        requestBodyTitle: "Request Body Parameters",
        firstNameDesc: "First name (minimum 3, maximum 50 characters).",
        lastNameDesc: "Last name (minimum 3, maximum 50 characters).",
        emailDesc: "Email (maximum 255 characters).",
        passwordDesc: "Optional lead password (minimum 6, maximum 20 characters). If omitted or null, CRM generates a password automatically.",
        phoneDesc: "Phone.",
        campaignDesc: "Name of the advertising campaign (minimum 2, maximum 255 characters).",
        secondPhoneDesc: "Second phone number (can be null).",
        extraInfoDesc: "Additional information (can be null).",
        geoDesc: "Geo. Allowed values: all, RU, SK, DK, LT, CZ, FR, LV, CY, NL, GE, HU, EE, GB, AT, FI, ME, KG, IE, PL, UA, PT, ES, MT, MC, NO, IT, IS, HR, GR, SE, BE, CH, DE, LU, US, HK, MY, UZ, PF, KG, AZ, AM, TJ, null.",
        curlTitle: "Request Example (cURL)",
        serverResponsesTitle: "Server Responses",
        successResponse: "Successful Request (201 Created)",
        domainError: "Domain Error (400 Bad Request)",
        unauthorizedError: "User Not Authenticated (401 Unauthorized)",
        validationError: "Validation Error (422 Unprocessable Entity)"
    },
};

export const PostLead = ({ affiliateToken, loading, error }) => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;

    const mainContainerClass = `${styles.mainContainer} ${theme === 'dark' ? styles.darkMainContainer : ''}`;
    const cardClass = `${styles.card} ${theme === 'dark' ? styles.darkCard : ''}`;
    const cardTitleClass = `${styles.cardTitle} ${theme === 'dark' ? styles.darkCardTitle : ''}`;
    const infoLabelClass = `${styles.infoLabel} ${theme === 'dark' ? styles.darkInfoLabel : ''}`;
    const infoValueClass = `${styles.infoValue} ${theme === 'dark' ? styles.darkInfoValue : ''}`;
    const paramKeyClass = `${styles.paramKey} ${theme === 'dark' ? styles.darkParamKey : ''}`;
    const paramDescriptionClass = `${styles.paramDescription} ${theme === 'dark' ? styles.darkParamDescription : ''}`;
    const codeInlineClass = `${styles.codeInline} ${theme === 'dark' ? styles.darkCodeInline : ''}`;
    const responseGroupClass = `${styles.responseGroup} ${theme === 'dark' ? styles.darkResponseGroup : ''}`;
    const responseSubTitleClass = `${styles.responseSubTitle} ${theme === 'dark' ? styles.darkResponseSubTitle : ''}`;
    const tokenClass = `${styles.token} ${theme === 'dark' ? styles.darkToken : ''}`;

    return (
        <div className={mainContainerClass}>
            <h2 className={`${styles.title} ${theme === 'dark' ? styles.darkTitle : ''}`}>{t.title}</h2>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.requestInfoTitle}</h3>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.urlLabel}</span>
                    <span className={infoValueClass}>{API_BASE_URL}/integration/lead/leads</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.methodLabel}</span>
                    <span className={infoValueClass}>POST</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.tokenLabel}</span>
                    <span className={tokenClass}>
                        {loading ? t.loading : error ? t.error : affiliateToken || t.missing}
                    </span>
                </div>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.requestParamsTitle}</h3>
                <ul className={styles.paramsList}>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>token</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>
                            {t.tokenDescription}
                            Пример: <code className={codeInlineClass}>n8902n02ed902me02ec</code>
                        </p>
                    </li>
                </ul>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.requestBodyTitle}</h3>
                <ul className={styles.paramsList}>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>first_name</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.firstNameDesc} Пример: <code className={codeInlineClass}>John</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>last_name</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.lastNameDesc} Пример: <code className={codeInlineClass}>Doe</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>email</span>
                            <span className={styles.paramMeta}>(обязательный, string, email)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.emailDesc} Пример: <code className={codeInlineClass}>john.doe@example.com</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>password</span>
                            <span className={styles.paramMeta}>(string, nullable)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.passwordDesc} Пример: <code className={codeInlineClass}>SecurePass123</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>phone</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.phoneDesc} Пример: <code className={codeInlineClass}>123456789</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>campaign</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.campaignDesc} Пример: <code className={codeInlineClass}>Facebook</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>second_phone</span>
                            <span className={styles.paramMeta}>(string, nullable)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.secondPhoneDesc} Пример: <code className={codeInlineClass}>987654321</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>extra_info</span>
                            <span className={styles.paramMeta}>(string, nullable)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.extraInfoDesc} Пример: <code className={codeInlineClass}>VIP client</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>geo</span>
                            <span className={styles.paramMeta}>(string, nullable)</span>
                        </div>
                        <p className={paramDescriptionClass}>
                            {t.geoDesc}
                        </p>
                    </li>
                </ul>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.curlTitle}</h3>
                <pre className={styles.codeBlock}>
                    <code>
                        curl --request POST \<br />
                        --url 'https://api.domain.com/api/v1/integration/lead/leads?token=ytHRy4uTBFCuiILC' \<br />
                        --header 'Accept: application/json' \<br />
                        --header 'Content-Type: application/json' \<br />
                        --data '{`{
    "first_name": "John",
    "last_name": "Doe",
    "email": "john.doe@example.com",
    "password": "SecurePass123",
    "phone": 123456789,
    "campaign": "Facebook",
    "second_phone": 987654321,
    "extra_info": "VIP client",
    "geo": "all"
}`}'
                    </code>
                </pre>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.serverResponsesTitle}</h3>
                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.successResponse}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
  "id": 1,
  "email": "email",
  "first_name": "First",
  "last_name": "Last",
  "phone": "09611499654",
  "sale_status": "New",
  "country": "Russia",
  "extra_info": "Russia",
  "geo": "all",
  "campaign": "Tesla",
  "created_at": "2025-01-01 00:00:00",
  "auto_login_url": "https://domain.com/en/api/users/4450/login/1751818071/84abb50c049d35a9dd84c937b3d9fdda0546852c555d56e985d467c6570c7c2b"
}`}
                        </code>
                    </pre>
                </div>

                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.domainError}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "errors": [
        {
            "code": "domain_error_code",
            "message": "Domain error message (always in English)",
            "context": [
                "helpful context 1",
                "helpful context 2"
            ]
        }
    ]
}`}
                        </code>
                    </pre>
                </div>

                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.unauthorizedError}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "message": "User is not authenticated. The user must log in to receive the authentication token."
}`}
                        </code>
                    </pre>
                </div>

                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.validationError}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "errors": {
        "first_name": [
            "The first name must be at least 3 characters."
        ],
        "last_name": [
            "The last name must be at least 3 characters."
        ],
        "email": [
            "The email must be a valid email address."
        ]
    }
}`}
                        </code>
                    </pre>
                </div>
            </div>
        </div>
    );
};
